import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ChannelIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M20 15l-6-5v3H8v4h6v3zM12 3H6V0L0 5l6 5V7h6z"/></svg>
        )
    }
}

export default withCssClassName(ChannelIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/channel-icon.js